var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"22","viewBox":"0 0 20 22"}},[_c('path',{attrs:{"d":"M7 15h10v2H7zM7 9h10v2H7zM7 3h10v2H7zM2 2h3v3H2zM2 8h3v3H2zM2 14h3v3H2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }